import { 
  Code, 
  Figma, 
  Github, 
  Atom, 
  Terminal, 
  FileCode, 
  Server,
  Database, 
  Layout, 
  LayoutGrid, 
  Layers, 
  Boxes,
  Box, 
  Webhook, 
  Globe, 
  Cpu, 
  Bookmark,
  Cloud, 
  BookOpen, 
  Bot, 
  Check,
  Calendar, 
  Table, 
  MessageSquare, 
  Binary,
  FileCog, 
  Lightbulb, 
  LineChart,
  Rocket, 
  Trello, 
  Zap, 
  Flag,
  Share2, 
  Scroll, 
  CloudCog, 
  Blocks, 
  CircuitBoard,
  Puzzle,
  Monitor,
  Workflow,
  PenTool,
  MailOpen,
  FormInput,
  Music,
  Wind,
  MousePointerClick,
  BarChart,
  Heart
} from 'lucide-react';

interface Tool {
  id: string;
  name: string;
  icon: React.ElementType;
  category: string;
}

export const availableTools: Tool[] = [
  // Development Technologies
  { id: 'javascript', name: 'JavaScript', icon: FileCode, category: 'Development' },
  { id: 'typescript', name: 'TypeScript', icon: FileCode, category: 'Development' },
  { id: 'react', name: 'React', icon: Atom, category: 'Development' },
  { id: 'angular', name: 'Angular', icon: Atom, category: 'Development' },
  { id: 'vue', name: 'Vue.js', icon: Atom, category: 'Development' },
  { id: 'svelte', name: 'Svelte', icon: Atom, category: 'Development' },
  { id: 'nextjs', name: 'Next.js', icon: () => <span className="font-bold">N</span>, category: 'Development' },
  { id: 'nodejs', name: 'Node.js', icon: Server, category: 'Development' },
  { id: 'deno', name: 'Deno', icon: Server, category: 'Development' },
  { id: 'python', name: 'Python', icon: Terminal, category: 'Development' },
  { id: 'java', name: 'Java', icon: FileCode, category: 'Development' },
  { id: 'csharp', name: 'C#', icon: FileCode, category: 'Development' },
  { id: 'go', name: 'Go', icon: FileCode, category: 'Development' },
  { id: 'rust', name: 'Rust', icon: FileCode, category: 'Development' },
  { id: 'php', name: 'PHP', icon: FileCode, category: 'Development' },
  { id: 'ruby', name: 'Ruby', icon: FileCode, category: 'Development' },
  { id: 'swift', name: 'Swift', icon: FileCode, category: 'Development' },
  { id: 'kotlin', name: 'Kotlin', icon: FileCode, category: 'Development' },
  { id: 'dart', name: 'Dart', icon: FileCode, category: 'Development' },
  { id: 'flutter', name: 'Flutter', icon: Layers, category: 'Development' },
  { id: 'html', name: 'HTML', icon: Code, category: 'Development' },
  { id: 'css', name: 'CSS', icon: Code, category: 'Development' },
  { id: 'sass', name: 'Sass', icon: Code, category: 'Development' },
  { id: 'tailwind', name: 'Tailwind CSS', icon: Layout, category: 'Development' },
  { id: 'bootstrap', name: 'Bootstrap', icon: Layout, category: 'Development' },
  { id: 'materialui', name: 'Material UI', icon: Box, category: 'Development' },
  { id: 'chakraui', name: 'Chakra UI', icon: LayoutGrid, category: 'Development' },
  
  // Design Tools
  { id: 'figma', name: 'Figma', icon: Figma, category: 'Design' },
  { id: 'sketch', name: 'Sketch', icon: Layout, category: 'Design' },
  { id: 'adobexd', name: 'Adobe XD', icon: Layout, category: 'Design' },
  { id: 'photoshop', name: 'Photoshop', icon: Layout, category: 'Design' },
  { id: 'illustrator', name: 'Illustrator', icon: Layout, category: 'Design' },
  { id: 'indesign', name: 'InDesign', icon: Layout, category: 'Design' },
  { id: 'aftereffects', name: 'After Effects', icon: Layout, category: 'Design' },
  { id: 'premierepro', name: 'Premiere Pro', icon: Layout, category: 'Design' },
  
  // Version Control & DevOps
  { id: 'git', name: 'Git', icon: Github, category: 'DevOps' },
  { id: 'github', name: 'GitHub', icon: Github, category: 'DevOps' },
  { id: 'gitlab', name: 'GitLab', icon: Github, category: 'DevOps' },
  { id: 'bitbucket', name: 'Bitbucket', icon: Github, category: 'DevOps' },
  { id: 'jenkins', name: 'Jenkins', icon: FileCog, category: 'DevOps' },
  { id: 'circleci', name: 'CircleCI', icon: FileCog, category: 'DevOps' },
  { id: 'travisci', name: 'Travis CI', icon: FileCog, category: 'DevOps' },
  { id: 'docker', name: 'Docker', icon: Box, category: 'DevOps' },
  { id: 'kubernetes', name: 'Kubernetes', icon: Boxes, category: 'DevOps' },
  { id: 'terraform', name: 'Terraform', icon: CloudCog, category: 'DevOps' },
  { id: 'ansible', name: 'Ansible', icon: CloudCog, category: 'DevOps' },
  
  // Databases
  { id: 'mysql', name: 'MySQL', icon: Database, category: 'Databases' },
  { id: 'postgresql', name: 'PostgreSQL', icon: Database, category: 'Databases' },
  { id: 'mongodb', name: 'MongoDB', icon: Database, category: 'Databases' },
  { id: 'redis', name: 'Redis', icon: Database, category: 'Databases' },
  { id: 'sqlite', name: 'SQLite', icon: Database, category: 'Databases' },
  { id: 'cassandra', name: 'Cassandra', icon: Database, category: 'Databases' },
  { id: 'couchdb', name: 'CouchDB', icon: Database, category: 'Databases' },
  { id: 'firebase', name: 'Firebase', icon: Zap, category: 'Databases' },
  { id: 'supabase', name: 'Supabase', icon: Database, category: 'Databases' },
  
  // AI/ML
  { id: 'pytorch', name: 'PyTorch', icon: Cpu, category: 'AI & ML' },
  { id: 'tensorflow', name: 'TensorFlow', icon: Cpu, category: 'AI & ML' },
  { id: 'keras', name: 'Keras', icon: Cpu, category: 'AI & ML' },
  { id: 'scikit-learn', name: 'scikit-learn', icon: Cpu, category: 'AI & ML' },
  { id: 'openai', name: 'OpenAI', icon: Bot, category: 'AI & ML' },
  { id: 'anthropic', name: 'Anthropic', icon: Bot, category: 'AI & ML' },
  { id: 'huggingface', name: 'Hugging Face', icon: Lightbulb, category: 'AI & ML' },
  { id: 'langchain', name: 'LangChain', icon: Lightbulb, category: 'AI & ML' },
  { id: 'midjourney', name: 'Midjourney', icon: Lightbulb, category: 'AI & ML' },
  { id: 'lovable', name: 'Lovable', icon: Heart, category: 'AI & ML' },
  { id: 'windsurf', name: 'Windsurf', icon: Wind, category: 'AI & ML' },
  { id: 'cursor', name: 'Cursor', icon: MousePointerClick, category: 'AI & ML' },
  { id: 'databutton', name: 'DataButton', icon: BarChart, category: 'AI & ML' },
  
  // Cloud Providers
  { id: 'aws', name: 'AWS', icon: Cloud, category: 'Cloud' },
  { id: 'azure', name: 'Azure', icon: CloudCog, category: 'Cloud' },
  { id: 'gcp', name: 'Google Cloud', icon: Cloud, category: 'Cloud' },
  { id: 'vercel', name: 'Vercel', icon: () => <span className="font-bold">▲</span>, category: 'Cloud' },
  { id: 'netlify', name: 'Netlify', icon: Cloud, category: 'Cloud' },
  { id: 'digitalocean', name: 'DigitalOcean', icon: Cloud, category: 'Cloud' },
  { id: 'heroku', name: 'Heroku', icon: Cloud, category: 'Cloud' },
  
  // Productivity Tools
  { id: 'vscode', name: 'VS Code', icon: Code, category: 'Productivity' },
  { id: 'intellij', name: 'IntelliJ', icon: Code, category: 'Productivity' },
  { id: 'notion', name: 'Notion', icon: BookOpen, category: 'Productivity' },
  { id: 'slack', name: 'Slack', icon: MessageSquare, category: 'Productivity' },
  { id: 'discord', name: 'Discord', icon: MessageSquare, category: 'Productivity' },
  { id: 'zoom', name: 'Zoom', icon: Share2, category: 'Productivity' },
  { id: 'trello', name: 'Trello', icon: Trello, category: 'Productivity' },
  { id: 'jira', name: 'Jira', icon: Flag, category: 'Productivity' },
  { id: 'asana', name: 'Asana', icon: Check, category: 'Productivity' },
  { id: 'airtable', name: 'Airtable', icon: Table, category: 'Productivity' },
  
  // No-Code Tools
  { id: 'webflow', name: 'Webflow', icon: Globe, category: 'No-Code' },
  { id: 'bubble', name: 'Bubble', icon: Puzzle, category: 'No-Code' },
  { id: 'zapier', name: 'Zapier', icon: Workflow, category: 'No-Code' },
  { id: 'wix', name: 'Wix', icon: Monitor, category: 'No-Code' },
  { id: 'framer', name: 'Framer', icon: PenTool, category: 'No-Code' },
  { id: 'shopify', name: 'Shopify', icon: Bookmark, category: 'No-Code' },
  { id: 'wordpress', name: 'WordPress', icon: BookOpen, category: 'No-Code' },
  { id: 'glideapps', name: 'Glide', icon: () => <span className="font-bold">G</span>, category: 'No-Code' },
  { id: 'mailchimp', name: 'Mailchimp', icon: MailOpen, category: 'No-Code' },
  { id: 'typeform', name: 'Typeform', icon: FormInput, category: 'No-Code' },
  { id: 'carrd', name: 'Carrd', icon: Layout, category: 'No-Code' },
  { id: 'retool', name: 'Retool', icon: Blocks, category: 'No-Code' },
  
  // Other
  { id: 'webgl', name: 'WebGL', icon: Globe, category: 'Other' },
  { id: 'threejs', name: 'Three.js', icon: Boxes, category: 'Other' },
  { id: 'unity', name: 'Unity', icon: Boxes, category: 'Other' },
  { id: 'unreal', name: 'Unreal Engine', icon: Boxes, category: 'Other' },
  { id: 'electron', name: 'Electron', icon: Atom, category: 'Other' },
  { id: 'tauri', name: 'Tauri', icon: Atom, category: 'Other' },
  { id: 'graphql', name: 'GraphQL', icon: Webhook, category: 'Other' },
  { id: 'rest', name: 'REST API', icon: Webhook, category: 'Other' },
  { id: 'blockchain', name: 'Blockchain', icon: Binary, category: 'Other' },
  { id: 'web3', name: 'Web3', icon: Globe, category: 'Other' },
]; 